import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import GlobalError from "./GlobalError";

//css
import "./css/root.css";
import "./css/index.css";
import "./css/login.css";
import "./css/sidebar.css";
import "./css/location.css";
import "./css/dark.css";
import "./css/loader.css";

//redux toolkit
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux";
import rootReducer from "./redux/reducers/rootReducer";

// Remove session/API state written by older builds.
localStorage.removeItem("persist:root");

const store = configureStore({
  reducer: rootReducer,
});


const originalError = console.error;
console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === 'string' &&
    args[0].includes("Failed prop type: The prop `attrValues` is marked as required")
  ) {
    return; // Ignore this specific warning
  }
  originalError(...args); // log as usual
};

ReactDOM.render(
  <GlobalError>
    <Provider store={store}>
      <App />
    </Provider>
  </GlobalError>,
  document.getElementById("root")
);
